<div class="row"
  style="padding-top: 80px;background-image: 'url(assets/images/002.jpeg)'; background-repeat: no-repeat;background-size: cover;">
  <div class="container">
    <div class="col-md-12">
      <h3 style="color: #fff;font-size: 22px;font-weight: 500">START YOUR SYSTEM ADMINISTRATION</h3>
      <p style="color: #FFC107;font-size: 12px;font-weight: 400">This is your Administration landing page. You can start
        your modification using the tiles <br /> Below are the mini tiles to access a specific settings</p>
    </div>
  </div>
</div>
<!-- <div class="row" style="padding-top: 20px;">
    <div class="container">
      <div class="col-md-4 col-xl-4">
        <div class="card bg-c-green order-card" style="padding: 10px;" (click)="Entity_List()">
          <div class="card-block" style="padding: 0px 0px 0px 0px">
            <h5 class="m-b-20" style="font-size: 15px;font-weight: 500;color: #519051;">Organization Setup</h5>
            <h2 class="text-right"><i style="float: right;margin-top: -30px;padding: 5px;color: #519051;font-size: 15px;border-radius: 50%;border: 2px solid #519051;" class="fa fa-sitemap"></i></h2>
  
          </div>
          <div class="op" style="margin-top: 20px;">
            <i class="fa fa-list-ul" (click)="Entity_List()" pTooltip="Organization List"></i>
            <i class="fa fa-user-plus" (click)="Add_Entity()" pTooltip="Add Organization"></i>
          </div>
        </div>
      </div>
      </div>
      </div> -->

<!-- /////////////////////////// -->




<section style="margin-top: 80px;">
  <div class="container-fluid">
    <div class="row" style="border: 1px solid;border-radius: 7px;margin: 4px; background-color: white;">
      <div class="col-md-12" (click)="pay()" style="font-size: 16px;font-weight: 800;padding: 17px">
        Activity Dashboards <i *ngIf="!payment" class="fa fa-arrow-circle-down coll-i" aria-hidden="true"></i><i
          *ngIf="payment" class="fa fa-arrow-circle-up coll-i" aria-hidden="true"></i>
      </div>

      <div class="row" *ngIf="payment" style="padding: 10px;">

        <div class="col-md-4 col-xl-4">
          <div class="card bg-c-blue order-card" (click)="showAllocatedDetails()">
            <div class="card-block">
              <h5 class="m-b-20">Accounts Allocated</h5>
              <h2 class="text-right"><i class="fa fa-id-card f-left"></i><span>{{DashboardData.allocated_count}}</span>
              </h2>

            </div>
          </div>
        </div>

        <div class="col-md-4 col-xl-4">
          <div class="card bg-c-blue order-card" (click)="showNotAllocatedDetails()">
            <div class="card-block">
              <h5 class="m-b-20">Accounts Not Allocated</h5>
              <h2 class="text-right"><i
                  class="fa fa-id-card f-left"></i><span>{{DashboardData.not_allocated_count}}</span></h2>

            </div>
          </div>
        </div>

        <div class="col-md-4 col-xl-4">
          <div class="card bg-c-pink order-card" (click)="showTouchedDetails()">
            <div class="card-block">
              <h5 class="m-b-20">Touched Accounts</h5>
              <h2 class="text-right"><i class="fa fa-id-card f-left"></i><span>{{DashboardData.touched_count}}</span>
              </h2>

            </div>
          </div>
        </div>

        <div class="col-md-4 col-xl-4">
          <div class="card bg-c-yellow order-card" (click)="showNotTouchedDetails()">
            <div class="card-block">
              <h5 class="m-b-20">Untouched Accounts</h5>
              <h2 class="text-right"><i
                  class="fa fa-id-card f-left"></i><span>{{DashboardData.not_touched_count}}</span></h2>

            </div>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="payment" style="padding: 10px;">
        <div class="col-md-12" *ngIf="displayAllocatedDialog" style="margin-top: 20px;">
          <div class="card" style="padding: 20px;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px;">
              <h5 style="margin: 0; font-weight: 600;">Accounts Allocated Details</h5>
              <button pButton type="button" icon="pi pi-file-excel" label="Export to Excel"
                (click)="exportTable(allocatedTable, allocatedDetails)" style="margin-left: auto;"></button>
            </div>
            <p-table #allocatedTable [value]="allocatedDetails" [paginator]="true" [rows]="10"
              [rowsPerPageOptions]="[5,10,20]">
              <ng-template pTemplate="header">
                <tr>
                  <th>S.No</th>
                  <th>Account No</th>
                  <th>CIF</th>
                  <th>Passport No</th>
                  <th>Customer Name</th>
                  <th>Agent Name</th>
                  <th>Date of Allocation</th>
                  <th>Card</th>
                  <th>Loan</th>
                  <th>Segment</th>
                  <th>CBQ Mob No</th>
                  <th>Email Address</th>
                  <th>Status Of Accounts</th>
                  <th>Contactable</th>
                  <th>Short Code</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
                <tr>
                  <td>{{rowIndex + 1}}</td>
                  <td>{{item.acc_no}}</td>
                  <td>{{item.cif}}</td>
                  <td>{{item.passport_no}}</td>
                  <td>{{item.customer_name}}</td>
                  <td>{{item.banker_name}}</td>
                  <td>{{item.date_of_allocations}}</td>
                  <td>{{item['Cr. Card Dues']}}</td>
                  <td>{{item['Loan Dues']}}</td>
                  <td>{{item['A/c Segment']}}</td>
                  <td>{{item['Qatar Mobile No']}}</td>
                  <td>{{item['Email ID']}}</td>
                  <td>{{item['Status Of Accounts']}}</td>
                  <td>{{item.Contactable}}</td>
                  <td>{{item['Short Code']}}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>

        <div class="col-md-12" *ngIf="displayNotAllocatedDialog" style="margin-top: 20px;">
          <div class="card" style="padding: 20px;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px;">
              <h5 style="margin: 0; font-weight: 600;">Accounts Not Allocated Details</h5>
              <button pButton type="button" icon="pi pi-file-excel" label="Export to Excel"
                (click)="exportTable(notAllocatedTable, notAllocatedDetails)" style="margin-left: auto;"></button>
            </div>
            <p-table #notAllocatedTable [value]="notAllocatedDetails" [paginator]="true" [rows]="10"
              [rowsPerPageOptions]="[5,10,20]">
              <ng-template pTemplate="header">
                <tr>
                  <th>S.No</th>
                  <th>Account No</th>
                  <th>CIF</th>
                  <th>Passport No</th>
                  <th>Customer Name</th>
                  <th>Agent Name</th>
                  <th>Date of Allocation</th>
                  <th>Card</th>
                  <th>Loan</th>
                  <th>Segment</th>
                  <th>CBQ Mob No</th>
                  <th>Email Address</th>
                  <th>Status Of Accounts</th>
                  <th>Contactable</th>
                  <th>Short Code</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
                <tr>
                  <td>{{rowIndex + 1}}</td>
                  <td>{{item.acc_no}}</td>
                  <td>{{item.cif}}</td>
                  <td>{{item.passport_no}}</td>
                  <td>{{item.customer_name}}</td>
                  <td>{{item.banker_name}}</td>
                  <td>{{item.date_of_allocations}}</td>
                  <td>{{item['Cr. Card Dues']}}</td>
                  <td>{{item['Loan Dues']}}</td>
                  <td>{{item['A/c Segment']}}</td>
                  <td>{{item['Qatar Mobile No']}}</td>
                  <td>{{item['Email ID']}}</td>
                  <td>{{item['Status Of Accounts']}}</td>
                  <td>{{item.Contactable}}</td>
                  <td>{{item['Short Code']}}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>

        <div class="col-md-12" *ngIf="displayTouchedDialog" style="margin-top: 20px;">
          <div class="card" style="padding: 20px;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px;">
              <h5 style="margin: 0; font-weight: 600;">Touched Accounts Details</h5>
              <button pButton type="button" icon="pi pi-file-excel" label="Export to Excel"
                (click)="exportTable(touchedTable, touchedDetails)" style="margin-left: auto;"></button>
            </div>
            <p-table #touchedTable [value]="touchedDetails" [paginator]="true" [rows]="10"
              [rowsPerPageOptions]="[5,10,20]">
              <ng-template pTemplate="header">
                <tr>
                  <th>S.No</th>
                  <th>Account No</th>
                  <th>CIF</th>
                  <th>Passport No</th>
                  <th>Customer Name</th>
                  <th>Agent Name</th>
                  <th>Date of Allocation</th>
                  <th>Card</th>
                  <th>Loan</th>
                  <th>Segment</th>
                  <th>CBQ Mob No</th>
                  <th>Email Address</th>
                  <th>Status Of Accounts</th>
                  <th>Contactable</th>
                  <th>Short Code</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
                <tr>
                  <td>{{rowIndex + 1}}</td>
                  <td>{{item.acc_no}}</td>
                  <td>{{item.cif}}</td>
                  <td>{{item.passport_no}}</td>
                  <td>{{item.customer_name}}</td>
                  <td>{{item.banker_name}}</td>
                  <td>{{item.date_of_allocations}}</td>
                  <td>{{item['Cr. Card Dues']}}</td>
                  <td>{{item['Loan Dues']}}</td>
                  <td>{{item['A/c Segment']}}</td>
                  <td>{{item['Qatar Mobile No']}}</td>
                  <td>{{item['Email ID']}}</td>
                  <td>{{item['Status Of Accounts']}}</td>
                  <td>{{item.Contactable}}</td>
                  <td>{{item['Short Code']}}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>

        <div class="col-md-12" *ngIf="displayNotTouchedDialog" style="margin-top: 20px;">
          <div class="card" style="padding: 20px;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px;">
              <h5 style="margin: 0; font-weight: 600;">Untouched Accounts Details</h5>
              <button pButton type="button" icon="pi pi-file-excel" label="Export to Excel"
                (click)="exportTable(notTouchedTable, notTouchedDetails)" style="margin-left: auto;"></button>
            </div>
            <p-table #notTouchedTable [value]="notTouchedDetails" [paginator]="true" [rows]="10"
              [rowsPerPageOptions]="[5,10,20]">
              <ng-template pTemplate="header">
                <tr>
                  <th>S.No</th>
                  <th>Account No</th>
                  <th>CIF</th>
                  <th>Passport No</th>
                  <th>Customer Name</th>
                  <th>Agent Name</th>
                  <th>Date of Allocation</th>
                  <th>Card</th>
                  <th>Loan</th>
                  <th>Segment</th>
                  <th>CBQ Mob No</th>
                  <th>Email Address</th>
                  <th>Status Of Accounts</th>
                  <th>Contactable</th>
                  <th>Short Code</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
                <tr>
                  <td>{{rowIndex + 1}}</td>
                  <td>{{item.acc_no}}</td>
                  <td>{{item.cif}}</td>
                  <td>{{item.passport_no}}</td>
                  <td>{{item.customer_name}}</td>
                  <td>{{item.banker_name}}</td>
                  <td>{{item.date_of_allocations}}</td>
                  <td>{{item['Cr. Card Dues']}}</td>
                  <td>{{item['Loan Dues']}}</td>
                  <td>{{item['A/c Segment']}}</td>
                  <td>{{item['Qatar Mobile No']}}</td>
                  <td>{{item['Email ID']}}</td>
                  <td>{{item['Status Of Accounts']}}</td>
                  <td>{{item.Contactable}}</td>
                  <td>{{item['Short Code']}}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>

    <div class="row" style="border: 1px solid;border-radius: 7px;margin: 4px;background-color: white;">
      <div class="col-md-12" (click)="asset()" style="font-size: 16px;font-weight: 800;padding: 17px;">
        Workflow Related <i *ngIf="!assets" class="fa fa-arrow-circle-down coll-i" aria-hidden="true"></i><i
          *ngIf="assets" class="fa fa-arrow-circle-up coll-i" aria-hidden="true"></i>
      </div>
      <div class="row" *ngIf="assets" style="padding: 10px;">
        <!-- <div class="col-md-2 col-xl-2">
    <div class="card bg-c-blue order-card" (click)="accallocate()">
        <div class="card-block">
            <h5 class="m-b-20">Skip Requested</h5>
            <h2 class="text-right"><i class="fa fa-id-card f-left"></i><span>76</span></h2>
  
        </div>
    </div>
  </div> -->

        <!-- <div class="col-md-2 col-xl-2">
      <div class="card bg-c-blue order-card" (click)="accallocate()">
          <div class="card-block">
              <h5 class="m-b-20">Skip updated</h5>
              <h2 class="text-right"><i class="fa fa-id-card f-left"></i><span>15</span></h2>
      
          </div>
      </div>
      </div> -->

        <div class="col-md-4 col-xl-4">
          <div class="card bg-c-pink order-card" (click)="accallocate()">
            <div class="card-block">
              <h5 class="m-b-20">Field visit reqeusted</h5>
              <h2 class="text-right"><i class="fa fa-id-card f-left"></i><span>{{FVRcount}}</span></h2>

            </div>
          </div>
        </div>

        <div class="col-md-4 col-xl-4">
          <div class="card bg-c-yellow order-card" (click)="accallocate()">
            <div class="card-block">
              <h5 class="m-b-20">Field visit Updated</h5>
              <h2 class="text-right"><i class="fa fa-id-card f-left"></i><span>{{FVCcount}}</span></h2>

            </div>
          </div>
        </div>

        <div class="col-md-4 col-xl-4">
          <div class="card bg-c-green order-card" (click)="accallocate()">
            <div class="card-block">
              <h5 class="m-b-20">Settlement Raised</h5>
              <h2 class="text-right"><i class="fa fa-id-card f-left"></i><span>{{SRcount.WaitingcreatenewSettle}}</span>
              </h2>

            </div>
          </div>
        </div>

        <div class="col-md-4 col-xl-4">
          <div class="card bg-c-blue order-card" (click)="accallocate()">
            <div class="card-block">
              <h5 class="m-b-20">Settlement Completed</h5>
              <h2 class="text-right"><i class="fa fa-id-card f-left"></i>
                <span>{{SCcount?.approvalWaitingcreatenewSettle}}</span>
              </h2>

            </div>
          </div>
        </div>

        <div class="col-md-4 col-xl-4">
          <div id="ptp-card" class="card bg-c-pink order-card" (click)="showPTPDetails()">
            <div class="card-block">
              <h5 class="m-b-20">PTP</h5>
              <h2 class="text-right"><i class="fa fa-id-card f-left"></i><span>{{PTPcount}}</span></h2>

            </div>
          </div>
        </div>

        <div class="col-md-12" *ngIf="displayPTPDialog" style="margin-top: 20px;">
          <div class="card" style="padding: 20px;">
            <h5 style="margin-bottom: 15px; font-weight: 600;">PTP Details</h5>
            <p-table [value]="PTPDetails" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[5,10,20]">
              <ng-template pTemplate="header">
                <tr>
                  <th>Customer ID</th>
                  <th>Passport No</th>
                  <th>Log Type</th>
                  <th>Substatus</th>
                  <th>Bcode</th>
                  <th>PTP Amount</th>
                  <th>Remarks</th>
                  <th>Creator Name</th>
                  <th>MOL Status</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-ptp>
                <tr>
                  <td>{{ptp.customer_id}}</td>
                  <td>{{ptp.passport_no}}</td>
                  <td>{{ptp.log_type}}</td>
                  <td>{{ptp.substatus}}</td>
                  <td>{{ptp.bcode}}</td>
                  <td>{{ptp.ptp_amount}}</td>
                  <td>{{ptp.remarks}}</td>
                  <td>{{ptp.creator_name}}</td>
                  <td>{{ptp.mol_status}}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>

        <!-- <div class="col-md-2 col-xl-2">
  <div class="card bg-c-yellow order-card" (click)="accallocate()">
      <div class="card-block">
        <h5 class="m-b-20">Criminal case completed</h5>
          <h2 class="text-right"><i class="fa fa-id-card f-left"></i><span>15</span></h2>
  
      </div>
  </div>
  </div>
  
  <div class="col-md-2 col-xl-2">
  <div class="card bg-c-green order-card" (click)="accallocate()">
      <div class="card-block">
        <h5 class="m-b-20">Criminal case released</h5>
          <h2 class="text-right"><i class="fa fa-id-card f-left"></i><span>25</span></h2>
  
      </div>
  </div>
  </div>
  
  <div class="col-md-2 col-xl-2">
  <div class="card bg-c-blue order-card" (click)="accallocate()">
      <div class="card-block">
        <h5 class="m-b-20">RPO reqeusted</h5>
          <h2 class="text-right"><i class="fa fa-id-card f-left"></i><span>35</span></h2>
  
      </div>
  </div>
  </div>
  
  <div class="col-md-2 col-xl-2">
  <div class="card bg-c-pink order-card" (click)="accallocate()">
      <div class="card-block">
        <h5 class="m-b-20">RPO completed</h5>
          <h2 class="text-right"><i class="fa fa-id-card f-left"></i><span>45</span></h2>
  
      </div>
  </div>
  </div>
  
  <div class="col-md-2 col-xl-2">
  <div class="card bg-c-yellow order-card" (click)="accallocate()">
      <div class="card-block">
        <h5 class="m-b-20">RPO released</h5>
          <h2 class="text-right"><i class="fa fa-id-card f-left"></i><span>19</span></h2>
  
      </div>
  </div>
  </div>
  
  <div class="col-md-2 col-xl-2">
  <div class="card bg-c-green order-card" (click)="accallocate()">
      <div class="card-block">
        <h5 class="m-b-20">Civil case requested</h5>
          <h2 class="text-right"><i class="fa fa-id-card f-left"></i><span>37</span></h2>
  
      </div>
  </div>
  </div>
  
  <div class="col-md-2 col-xl-2">
  <div class="card bg-c-blue order-card" (click)="accallocate()">
      <div class="card-block">
        <h5 class="m-b-20">Civil case completed</h5>
          <h2 class="text-right"><i class="fa fa-id-card f-left"></i><span>82</span></h2>
  
      </div>
  </div>
  </div>
  
  <div class="col-md-2 col-xl-2">
  <div class="card bg-c-pink order-card" (click)="accallocate()">
      <div class="card-block">
        <h5 class="m-b-20">Civil case released</h5>
          <h2 class="text-right"><i class="fa fa-id-card f-left"></i><span>46</span></h2>
  
      </div>
  </div>
  </div> -->
      </div>
    </div>
    <!-- <div class="row" style="border: 1px solid;border-radius: 7px;margin: 4px;background-color: white;">
    <div class="col-md-12" (click)="asset1()" style="font-size: 16px;font-weight: 800;padding: 17px;">
      Product Dashboards <i *ngIf="!assets1"
      class="fa fa-arrow-circle-down coll-i" aria-hidden="true"></i><i *ngIf="assets1"
      class="fa fa-arrow-circle-up coll-i" aria-hidden="true"></i>
      </div>
      <div class="row" *ngIf="assets1" style="padding: 10px;">
    <div class="col-md-2 col-xl-2">
      <div class="card bg-c-blue order-card" (click)="creditcardlist()">
          <div class="card-block">
              <h5 class="m-b-20">Credit Card</h5>
              <h2 class="text-right"><i class="fa fa-id-card f-left"></i><span>25</span></h2>
  
          </div>
      </div>
  </div>
  <div class="col-md-2 col-xl-2">
    <div class="card bg-c-pink order-card" (click)="vehicleloanlist()">
        <div class="card-block">
            <h5 class="m-b-20">Vehicle Loan</h5>
            <h2 class="text-right"><i class="fa fa-id-card f-left"></i><span>20</span></h2>
  
        </div>
    </div>
  </div>
  <div class="col-md-2 col-xl-2">
  <div class="card bg-c-yellow order-card" (click)="personalloanlist()">
      <div class="card-block">
          <h5 class="m-b-20">Personal Loan</h5>
          <h2 class="text-right"><i class="fa fa-id-card f-left"></i><span>10</span></h2>
  
      </div>
  </div>
  </div>
  <div class="col-md-2 col-xl-2">
  <div class="card bg-c-green order-card" (click)="homeloanlist()">
      <div class="card-block">
          <h5 class="m-b-20">Home Loan</h5>
          <h2 class="text-right"><i class="fa fa-id-card f-left"></i><span>5</span></h2>
      </div>
  </div>
  </div>
  <div class="col-md-2 col-xl-2">
  <div class="card bg-c-blue order-card" (click)="homeloanlist()">
      <div class="card-block">
          <h5 class="m-b-20">Auto Loan</h5>
          <h2 class="text-right"><i class="fa fa-id-card f-left"></i><span>5</span></h2>
  
      </div>
  </div>
  </div>
  <div class="col-md-2 col-xl-2">
  <div class="card bg-c-pink order-card" (click)="homeloanlist()">
      <div class="card-block">
          <h5 class="m-b-20">Business Loan</h5>
          <h2 class="text-right"><i class="fa fa-id-card f-left"></i><span>5</span></h2>
  
      </div>
  </div>
  </div>
  <div class="col-md-2 col-xl-2">
  <div class="card bg-c-yellow order-card" (click)="homeloanlist()">
      <div class="card-block">
          <h5 class="m-b-20">Buiness Vehicle Loan</h5>
          <h2 class="text-right"><i class="fa fa-id-card f-left"></i><span>5</span></h2>
  
      </div>
  </div>
  </div>
  <div class="col-md-2 col-xl-2">
  <div class="card bg-c-green order-card" (click)="homeloanlist()">
      <div class="card-block">
          <h5 class="m-b-20">Etisalat</h5>
          <h2 class="text-right"><i class="fa fa-id-card f-left"></i><span>5</span></h2>
  
      </div>
  </div>
  </div>
  <div class="col-md-2 col-xl-2">
  <div class="card bg-c-blue order-card" (click)="homeloanlist()">
      <div class="card-block">
          <h5 class="m-b-20">DU</h5>
          <h2 class="text-right"><i class="fa fa-id-card f-left"></i><span>5</span></h2>
  
      </div>
  </div>
  </div>
  </div>
  </div> -->

    <!-- <div class="row" style="border: 1px solid;border-radius: 7px;margin: 4px;background-color: white;">
    <div class="col-md-12" (click)="asset2()" style="font-size: 16px;font-weight: 800;padding: 17px;">
      Performance Dashboard <i *ngIf="!assets2"
      class="fa fa-arrow-circle-down coll-i" aria-hidden="true"></i><i *ngIf="assets2"
      class="fa fa-arrow-circle-up coll-i" aria-hidden="true"></i>
      </div>
      <div class="row" *ngIf="assets2" style="padding: 10px;">
          <div style="display: block" class="col-md-4">
            <div class="col-md-12" style="text-align: center;font-weight: 800;padding: 10px;">
              Productivity Target VS Actual
            </div>
            <canvas baseChart
                    [datasets]="barChartData"
                    [labels]="barChartLabels"
                    [options]="barChartOptions"
                    [legend]="barChartLegend"
                    [chartType]="barChartType">
            </canvas>
          </div>
  
  
        <div style="display: block" class="col-md-4">
          <div class="col-md-12" style="text-align: center;font-weight: 800;padding: 10px;">
            Resolutions Total Allocated VS Actual Resolved
          </div>
          <canvas baseChart
                      [data]="doughnutChartData"
                      [labels]="doughnutChartLabels"
                      [chartType]="doughnutChartType"></canvas>
        </div>
  
  
  
        <div style="display: block" class="col-md-4">
          <div class="col-md-12" style="text-align: center;font-weight: 800;padding: 10px;">
            Cash collection target vs cash collected
          </div>
          <canvas baseChart
                  [datasets]="radarChartData"
                  [labels]="radarChartLabels"
                  [chartType]="radarChartType"></canvas>
        </div>
  
  
        <div style="display: block" class="col-md-4">
          <div class="col-md-12" style="text-align: center;font-weight: 800;padding: 10px;">
            Attendance calendar
          </div>
          <canvas baseChart
                  [datasets]="barChartData"
                  [labels]="barChartLabels"
                  [options]="barChartOptions"
                  [legend]="barChartLegend"
                  [chartType]="barChartType">
          </canvas>
        </div>
  
  
        <div style="display: block" class="col-md-4">
          <div class="col-md-12" style="text-align: center;font-weight: 800;padding: 10px;">
           Login - Logout
          </div>
          <canvas baseChart
                  [data]="pieChartData"
                  [labels]="pieChartLabels"
                  [chartType]="pieChartType"></canvas>
        </div>
  
  
        <div style="display: block" class="col-md-4">
          <div class="col-md-12" style="text-align: center;font-weight: 800;padding: 10px;">
            Allocations + Tos + Pos + Target
          </div>
          <canvas baseChart
                  [datasets]="barChartData"
                  [labels]="barChartLabels"
                  [options]="barChartOptions"
                  [legend]="barChartLegend"
                  [chartType]="barChartType">
          </canvas>
        </div>
  
        <div style="display: block" class="col-md-4">
          <div class="col-md-12" style="text-align: center;font-weight: 800;padding: 10px;">
            Performance Tranding
          </div>
          <canvas baseChart
                  [datasets]="radarChartData"
                  [labels]="radarChartLabels"
                  [chartType]="radarChartType"></canvas>
        </div>
  </div>
  </div> -->
    <!-- <div class="row" style="margin-top: 11px;">
          <div class="col-md-12 col-xl-12">
            <a class="work" (click)="dash()">Go to your Worklist</a>
            <a class="work" (click)="Adhoc()">Adhoc Contact Recording</a>
            <a class="work blinking" (click)="dash()">Priority Worklist</a>
        </div>
        </div> -->

    <!-- <div class="row" style="border: 1px solid;border-radius: 7px;margin: 4px;background-color: white;">
  <div style="display: block" class="col-md-4">
    <div class="col-md-12" style="text-align: center;font-weight: 800;padding: 10px;">
      Productivity Target VS Actual
    </div>
    <canvas baseChart
            [datasets]="barChartData"
            [labels]="barChartLabels"
            [options]="barChartOptions"
            [legend]="barChartLegend"
            [chartType]="barChartType">
    </canvas>
  </div>
  <div style="display: block" class="col-md-4">
  <div class="col-md-12" style="text-align: center;font-weight: 800;padding: 10px;">
    Resolutions Total Allocated VS Actual Resolved
  </div>
  <canvas baseChart
              [data]="doughnutChartData"
              [labels]="doughnutChartLabels"
              [chartType]="doughnutChartType"></canvas>
  </div>
  <div style="display: block" class="col-md-4">
  <div class="col-md-12" style="text-align: center;font-weight: 800;padding: 10px;">
    Cash collection target vs cash collected
  </div>
  <canvas baseChart
          [datasets]="radarChartData"
          [labels]="radarChartLabels"
          [chartType]="radarChartType"></canvas>
  </div>
  <div style="display: block" class="col-md-4">
  <div class="col-md-12" style="text-align: center;font-weight: 800;padding: 10px;">
    Attendance calendar
  </div>
  <canvas baseChart
          [datasets]="barChartData"
          [labels]="barChartLabels"
          [options]="barChartOptions"
          [legend]="barChartLegend"
          [chartType]="barChartType">
  </canvas>
  </div>
  <div style="display: block" class="col-md-4">
  <div class="col-md-12" style="text-align: center;font-weight: 800;padding: 10px;">
   Login - Logout
  </div>
  <canvas baseChart
          [data]="pieChartData"
          [labels]="pieChartLabels"
          [chartType]="pieChartType"></canvas>
  </div>
  <div style="display: block" class="col-md-4">
  <div class="col-md-12" style="text-align: center;font-weight: 800;padding: 10px;">
    Allocations + Tos + Pos + Target
  </div>
  <canvas baseChart
          [datasets]="barChartData"
          [labels]="barChartLabels"
          [options]="barChartOptions"
          [legend]="barChartLegend"
          [chartType]="barChartType">
  </canvas>
  </div>
  <div style="display: block" class="col-md-4">
  <div class="col-md-12" style="text-align: center;font-weight: 800;padding: 10px;">
    Performance Tranding
  </div>
  <canvas baseChart
          [datasets]="radarChartData"
          [labels]="radarChartLabels"
          [chartType]="radarChartType"></canvas>
  </div>
        </div> -->
  </div>
</section>